import { BrowserRouter as Router, Route, Routes } from "react-router-dom";
import SignUp from "../auth/signUp";
import Dashboard from "../dashboard/dashboard";
import Home from "../home/home";
import Login from "../auth/login";
import PrivateRoute from "./PrivateRoute";
import Page404 from "../../pages/page404";
import Referral from "../network/referral";
import Investment from "../reports/investment/investment";
import DirectTeam from "../network/directTeam";
import TotalTeam from "../network/totalTeam";
import Profile from "../dashboard/profile";
import DefaultHome from "../home/defaultHome";
import IncomeReport from "../reports/income/incomeReport";
import IncomeWise from "../reports/incomeWise/incomeWise";
import TargetWise from "../reports/targetWise/targetWise";
import LevelWiseUserCount from "../reports/levelWiseUserCount/levelWiseUserCount";
import WithdrawalReport from "../reports/withdrawal/withdrawalReport";
import DirectBusiness from "../reports/sponsor/directBusiness/directBusiness";
import SponsorBusiness from "../reports/sponsor/sponsorBusiness/sponsorBusiness";
import SelfBusiness from "../reports/sponsor/selfBusiness/selfBusiness";
import LedgerReport from "../reports/ledger/ledgerReport";
import ContractComp from "../contract";


const AllRoutes = () => {
    return (
        <Router>
            <Routes>
                <Route path="/" element={<DefaultHome />} />
                {/* <Route path="/" element={<Website />} /> */}
                <Route path="/login" element={<Login />} />
                <Route path="/home" element={<Home />} />
                <Route path="/signup" element={<SignUp />} />
                <Route path="/signup/:referral" element={<SignUp />} />
                <Route
                    path="/dashboard"
                    element={
                        <PrivateRoute>
                            <Dashboard />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/investment"
                    element={
                        <PrivateRoute>
                            <Investment />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/referral"
                    element={
                        <PrivateRoute>
                            <Referral />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/direct-team"
                    element={
                        <PrivateRoute>
                            <DirectTeam />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/total-team"
                    element={
                        <PrivateRoute>
                            <TotalTeam />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/profile"
                    element={
                        <PrivateRoute>
                            <Profile />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/income"
                    element={
                        <PrivateRoute>
                            <IncomeReport />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/level_target_details"
                    element={
                        <PrivateRoute>
                            <TargetWise />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/level_usercount_details"
                    element={
                        <PrivateRoute>
                            <LevelWiseUserCount />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/income_details"
                    element={
                        <PrivateRoute>
                            <IncomeWise />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/withdrawal"
                    element={
                        <PrivateRoute>
                            <WithdrawalReport />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/direct-business"
                    element={
                        <PrivateRoute>
                            <DirectBusiness />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/sponsor-business"
                    element={
                        <PrivateRoute>
                            <SponsorBusiness />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/self-business"
                    element={
                        <PrivateRoute>
                            <SelfBusiness />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/ledger"
                    element={
                        <PrivateRoute>
                            <LedgerReport />
                        </PrivateRoute>
                    }
                />
                <Route
                    path="/contract"
                    element={
                        <PrivateRoute>
                            <ContractComp />
                        </PrivateRoute>
                    }
                />

                <Route path="*" element={<Page404 />} />
            </Routes>
        </Router>
    );
};

export default AllRoutes;
